import React from 'react';
import { FiCheck, FiX } from 'react-icons/fi';

export default function SimsysExamEditor({ 
  isOpen, 
  onClose, 
  onSave,
  initialData = { link: '' }
}) {
  const [link, setLink] = React.useState(initialData.link || '');

  const handleSave = () => {
    onSave({ link });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div 
      style={{ 
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 100001,
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        border: '1px solid #ddd',
        minWidth: '400px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      }}
      onClick={e => e.stopPropagation()}
    >
      <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: '600' }}>
        Simsys Prüfung
      </h3>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <label style={{ minWidth: '120px', fontSize: '14px', fontWeight: 'normal', textAlign: 'left' }}>
            Link:
          </label>
          <input
            type="url"
            value={link}
            onChange={e => setLink(e.target.value)}
            placeholder="https://simsys.example.com/exams/..."
            style={{ 
              fontSize: '14px', 
              padding: '8px 12px', 
              flex: 1, 
              minWidth: '200px', 
              borderRadius: '6px', 
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            autoFocus
            onFocus={e => e.target.style.borderColor = '#4caf50'}
            onBlur={e => e.target.style.borderColor = '#ccc'}
          />
        </div>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #ddd' }}>
        <button
          style={{ 
            cursor: 'pointer', 
            color: 'white',
            backgroundColor: '#4caf50',
            border: 'none',
            padding: '10px 16px', 
            borderRadius: '6px', 
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'background-color 0.2s'
          }}
          onClick={handleSave}
          onMouseEnter={e => e.target.style.backgroundColor = '#45a049'}
          onMouseLeave={e => e.target.style.backgroundColor = '#4caf50'}
        >
          <FiCheck />
          Speichern
        </button>
        <button
          style={{ 
            cursor: 'pointer', 
            color: 'white',
            backgroundColor: '#f44336',
            border: 'none',
            padding: '10px 16px', 
            borderRadius: '6px', 
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'background-color 0.2s'
          }}
          onClick={onClose}
          onMouseEnter={e => e.target.style.backgroundColor = '#da190b'}
          onMouseLeave={e => e.target.style.backgroundColor = '#f44336'}
        >
          <FiX />
          Abbrechen
        </button>
      </div>
    </div>
  );
}
